import React, { useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Tab, Tabs, withWidth } from '@material-ui/core';
import { checkWidthDown } from '../../../utilities/Utils';
import { Typography } from 'antd';
import EventDetailInformation from './EventDetailInformation/index';
import EventDetailParticipant from './EventDetailParticipant/index';
import {
    useHistory,
    useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import UseLoadingState from '../../../control/loading/UseLoadingState';
import UseAlertMessageState from '../../../control/alert/UseAlertMessageState';
import { checkResStatusService } from '../../../utilities/ResServiceUtils';
import * as AlertMSGConstants from '../../../constants/AlertMSGConstants';
import { connect } from 'react-redux';
import * as ApiEvent from '../../../api/ApiEvent';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
            style={{
                height: '100%',
                overflowY: 'auto',
                overflowX: 'hidden',
            }}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const a11yProps = (index) => {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
};

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        width: '100%',
        height: '100%',
    },
    rootPaper: {
        width: '100%',
        height: '100%',
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        paddingTop: '24px',
        height: '100%',
        width: '245px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            paddingLeft: '0px',
            paddingTop: '20px',
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
    },
    wrapper: {
        alignItems: 'flex-end',
        fontSize: '20px',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
        },
    },
    selected: {
        backgroundColor: '#F47B15',
        color: '#FFFFFF',
        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'white',
            color: 'gray',
            borderBottom: '3px solid #F47B15',
        },
    },
    body: {
        width: '100%',
        fontSize: '20px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    btnCancel: {
        width: '90%',
        marginBottom: '24px',
        position: 'absolute',
        bottom: '0px',
        color: '#FFFFFF',
        marginLeft: '5%',
        backgroundColor: theme.mainTheme.color3,
        '&:hover': {
            color: '#FFFFFF',
            backgroundColor: theme.mainTheme.color3,
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    positionBtn2: {
        bottom: '50px !important',
        [theme.breakpoints.down('sm')]: {
            bottom: '0px !important',
        },
    },
    rootTab: {
        maxWidth: '100%',
    },
    CanceledMsg: {
        color: theme.mainTheme.color3,
        marginBottom: '30px',
        position: 'absolute',
        bottom: '0px',
        alignSelf: 'center',
        [theme.breakpoints.down('sm')]: {
            width: 'auto',
            margin: '0px',
            position: 'absolute',
            right: '24px',
            marginBottom: '7px',
        },
    },
    flexContainer: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
        },
    },
    indicator: {
        display: 'none',
    },
    panel: {
        height: '100%',
        width: '245px',
        backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: '72px',
        },
    },
    children: {
        height: '100%',
        width: 'calc(100% - 245px)',
        backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: 'calc(100% - 72px)',
        },
    },
    tabCancelAbsence: {
        color: theme.mainTheme.color3,
        opacity: '1 !important',
    },
}));

const EventManagementDetail = (props) => {
    const classes = useStyles();
    const { width, authenRdc } = props;
    const [value, setValue] = React.useState(0);
    const isSmDowm = checkWidthDown(width, 'sm');
    const loadingState = UseLoadingState();
    const alertMessageState = UseAlertMessageState();
    const { eventId } = useParams();
    const [eventData, setEventData] = React.useState();
    const history = useHistory();

    const fetchData = useCallback(async () => {
        loadingState.showLoading();
        try {
            const parameters = { userId: authenRdc.profile.uuid };
            const response = await ApiEvent.fetchEventById(eventId, parameters);
            loadingState.hideLoading();
            if (response.data) {
                setEventData(response.data);
            } else {
                alertMessageState.showAlert({
                    altMsg:
                        checkResStatusService(response) ||
                        AlertMSGConstants.SYSTEM_ERROR,
                });
            }
        } catch (error) {
            loadingState.hideLoading();
            if (error.status === 404) {
                alertMessageState.showAlert({
                    altMsg: 'ไม่พบข้อมูลกิจกรรม ระบบจะนำท่านกลับเข้าสู่หน้าหลัก',
                    callbackCancel: () => {
                        history.push(`/event`);
                    },
                });
            } else {
                alertMessageState.showAlert({
                    altMsg: AlertMSGConstants.SYSTEM_ERROR,
                });
            }
        }
    }, [alertMessageState, loadingState, eventId, authenRdc, history]);

    useEffect(() => {
        fetchData();
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Grid container className={classes.rootPaper}>
            <Grid item className={classes.panel}>
                <Tabs
                    orientation={isSmDowm ? 'horizontal' : 'vertical'}
                    variant="scrollable"
                    role="tabpanel"
                    scrollButtons={isSmDowm ? 'on' : 'off'}
                    indicatorColor="primary"
                    value={value}
                    onChange={handleChange}
                    className={classes.tabs}
                    classes={{ indicator: classes.indicator }}
                >
                    <Tab
                        classes={{
                            wrapper: classes.wrapper,
                            selected: classes.selected,
                            root: classes.rootTab,
                        }}
                        label="ข้อมูลกิจกรรม"
                        {...a11yProps(0)}
                    />
                    <Tab
                        classes={{
                            wrapper: classes.wrapper,
                            selected: classes.selected,
                            root: classes.rootTab,
                        }}
                        label="ข้อมูลผู้ลงทะเบียนกิจกรรม"
                        {...a11yProps(1)}
                    />
                </Tabs>
            </Grid>
            <Grid item className={classes.children}>
                <TabPanel value={value} index={0}>
                    <EventDetailInformation
                        eventData={eventData}
                        alertMessageState={alertMessageState}
                        loadingState={loadingState}
                    />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <EventDetailParticipant
                        eventData={eventData}
                        setEventData={setEventData}
                        alertMessageState={alertMessageState}
                        loadingState={loadingState}
                    />
                </TabPanel>
            </Grid>
        </Grid>
    );
};

export default withWidth()(
    connect((state) => ({
        authenRdc: state.authen,
    }))(EventManagementDetail)
);
